import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output, QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';

@Component({
  selector: 'exg-tab',
  templateUrl: './exg-tab.component.html',
  styles: []
})
export class ExgTabComponent implements OnInit, AfterViewInit {

  _selectedtab = 0;

  @Input() header!: Array<ExgTabComponentHeaderElement>;

  @Input() set selectedtab(value: number) {
    // externes setzen des tabs, interner Setter bei onTabClick
    const e: ElementRef | any = this.tabs.toArray()[value];
    this.onTabClick(value, e.nativeElement);
  }

  get selectedtab(): number {
    return this._selectedtab;
  }

  @ContentChild('pages') pages?: TemplateRef<ElementRef>;

  @Output() tabchange: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild('container') container!: ElementRef;
  @ViewChild('headercontainer') headercontainer!: ElementRef;
  @ViewChildren('xyz', {read: Element}) tabs!: QueryList<Element>;


  private scroll = 0;

  get style(): string {
    return `transform: translate(${this.scroll}px,0);`;
  }

  private contentscroll = 0;

  get contentstyle(): string {
    return `transform: translate(${this.contentscroll}px,0)`;
  }


  constructor() {
  }

  ngOnInit(): void {

  }

  onTabClick(i: number, element: Element): void {
    /* Change selected Tab and toggle hidden attribute */
    if (i !== this._selectedtab) {
      if (this.container.nativeElement.querySelector('.tab-content').children.length > i) {
        this.container.nativeElement.querySelector('.tab-content').children[i].removeAttribute('hidden');
      }
      if (this.container.nativeElement.querySelector('.tab-content').children.length > this._selectedtab) {
        this.container.nativeElement.querySelector('.tab-content').children[this._selectedtab].setAttribute('hidden', true);
      }
    }
    const viewport = (this.container.nativeElement as Element).getBoundingClientRect();
    const tabcontainer = (this.headercontainer.nativeElement as Element).scrollWidth;
    const elementLeft = element.getBoundingClientRect().left - viewport.x;
    const elementRight = element.getBoundingClientRect().right - viewport.x;
    const htmlelement = (element as HTMLElement);

    const maxScroll = tabcontainer * -1 + viewport.width - 16;


    if (elementRight > viewport.width - 48) {
      this.scroll = htmlelement.offsetLeft * -1;
    }
    if (elementLeft < 48) {
      this.scroll = htmlelement.offsetLeft * -1 + viewport.width - htmlelement.offsetWidth - 16;
    }

    if (this.scroll < maxScroll) {
      this.scroll = maxScroll;
    }
    if (this.scroll > 0) {
      this.scroll = 0;
    }

    // nur feuern wenn nicht extern gesetzt wird
    this._selectedtab = i;
    this.tabchange.emit(this._selectedtab);

    /* Check if hidden attibute takes effect and correct visible tab multiplier for contentscroll */
    let multiplier = this.selectedtab;
    for (let index = 0; index < this.container.nativeElement.querySelector('.tab-content').children.length; index++) {
      if (this.container.nativeElement.querySelector('.tab-content').children[index].clientWidth === 0) {
        multiplier--;
      }
    }
    if (multiplier < 0) {
      multiplier = 0;
    }
    this.contentscroll = multiplier * viewport.width * -1;

  }

  onWheel(e: WheelEvent): void {

    e.preventDefault();
    const viewport = (this.container.nativeElement as Element).getBoundingClientRect().width;
    const elementWidth = (this.headercontainer.nativeElement as Element).scrollWidth;
    const maxScroll = elementWidth * -1 + viewport - 16;

    this.scroll = this.scroll + e.deltaY;

    if (this.scroll < maxScroll) {
      this.scroll = maxScroll;
    }
    if (this.scroll > 0) {
      this.scroll = 0;
    }

  }

  ngAfterViewInit(): void {
    /* Initialize and set hidden attribute to all not selectedTabs */
    for (let i = 0; i < this.container.nativeElement.querySelector('.tab-content').children.length; i++) {
      if (i === this._selectedtab) {
        this.container.nativeElement.querySelector('.tab-content').children[i].removeAttribute('hidden');
      } else {
        this.container.nativeElement.querySelector('.tab-content').children[i].setAttribute('hidden', true);
      }
    }
  }

}

export type ExgTabComponentHeaderElement = {
  caption: string;
  icon_class: string;
  disabled?: boolean;
  data?: any | undefined;
};
